const validate = (values) => {
  const errors = {};
  if (!values.currentPassword) {
    errors.currentPassword = 'Please enter current password';
  }
  // if (!values.newPassword) {
  //   errors.newPassword = 'Please enter new password';
  // }
  if (!values.newPassword || values.newPassword.trim() === '') {
    errors.newPassword = 'Please enter password';
  } else if (!/^(?=.{8,30}$)/.test(values.newPassword)) {
    errors.newPassword = 'Password should contain minimum 8 and maximum 30 characters';
  } else {
    let pError = [], prefix = '';
    if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\+\-\_\@\#\$\%\&\!\,\[\]\{\}\(\)\|])/.test(values.newPassword)) {
      prefix = 'Password should contain atleast ';
    }
    if (!/^(?=.*[a-z])/.test(values.newPassword)) {
      pError.push('1 lowercase character');
    }
    if (!/^(?=.*[A-Z])/.test(values.newPassword)) {
      pError.push('1 uppercase character');
    }
    if (!/^(?=.*[0-9])/.test(values.newPassword)) {
      pError.push('1 numeric value');
    }
    if (!/^(?=.*[\+\-\_\@\#\$\%\&\!\,\[\]\{\}\(\)\|])/.test(values.newPassword)) {
      pError.push('1 special character');
    }
    errors.newPassword = prefix + pError.join(', ');
  }

  if (!values.confirmNewPassword) {
    errors.confirmNewPassword = 'Please confirm new password';
  } else if (values.confirmNewPassword !== values.newPassword) {
    errors.confirmNewPassword = 'Password mismatched';
  }

  // Check if the new password is same as the current password
  if (values.newPassword === values.currentPassword) {
    errors.newPassword = 'New password cannot be the same as current password';
  }

  return errors;
};
export default validate;



// WEBPACK FOOTER //
// ./src/components/validateChangePassword.js